<template>

    <!-- Page Sidebar Ends-->
    <div class="page-body">
        <PageTitle title="Employees" />
        <div class="container-fluid">
            <div class="row">
                <div class="col-lg-12">
                    <div class="card">
                        <div class="card-header">
                            <button class="btn btn-secondary" type="button" data-bs-toggle="modal"
                                data-original-title="test" data-bs-target="#employeeAdd">Add Employee</button>
                        </div>
                        <div class="card-body badge-spacing">
                            <div class="table-responsive custom-scrollbar">
                                <table class="table display" id="basic-1">
                                    <thead>
                                        <tr>
                                            <th>Code</th>
                                            <th>Name</th>
                                            <th>Contact</th>
                                            <th>Department</th>
                                            <th>Password</th>
                                            <th>Role</th>
                                            <th>Status</th>
                                            <th>Action</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        <tr  v-for="(item ,index)  in employees" :key="item.id" >
                                            <td>{{item.empcode}}</td>
                                            <td>{{item.empname}}</td>
                                            <td>{{item.contact}}</td>
                                            <td>{{item.dept_name}}</td>
                                            <td>{{item.emppwd}}</td>
                                            <td>
                                                <span v-if="item.emprole==1">ADMIN</span>
                                                <span v-else-if="item.emprole==2">HOD</span>
                                                <span v-else-if="item.emprole==3">Employee</span>
                                            </td>
                                            <td>{{(item.empstatus==1)?'Active':'De-Active'}}</td>
                                            <td>
                                                <ul class="action">
                                                    <li class="edit" @click="edit_employee(item)"><i class="icon-pencil-alt"></i></li>
                                                    <li class="delete" @click="remove_employee(item.id)"><i class="icon-trash"></i></li>
                                                </ul>
                                            </td>
                                        </tr>
                                    </tbody>
                                </table>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <!-- footer   start-->

    <ModalsPart v-if="!['login'].includes($route.name)"  @getEmpData="updateEmpData" :edit_emp_row="editEmployee"/>
</template>

<script>
// @ is an alias to /src 
import PageTitle from '@/components/PageTitle.vue';
import ModalsPart from '@/components/Modals.vue';
import axios from 'axios';
const config = {
            headers: {
               "Content-Type": "application/x-www-form-urlencoded"
            },
            responseType: 'json'
         };
export default {
    name: 'Users', 
    components: {
        PageTitle, ModalsPart
    }, mounted() {
        this.getBasics();

    }, data() {
        return {
          employees: [],
          editEmployee:[]
        }
    },
    methods: { 
        updateEmpData(value) {
            this.employees = value;
        },
        getBasics() {
            var self = this;
            axios.post('getEmployees').then(function (response) {
                self.employees = response.data.employees; 
                window.scrollTo(0, 0);
            });
        },
        remove_employee(id) {
            var self = this;
            axios.post('removeEmployee', {emp_id:id}).then(function (response) {
                self.employees = response.data.employees; 
                window.scrollTo(0, 0);
            });
        },
        edit_employee(item)
        {
            var self = this;
            self.editEmployee = item; 
            $("#employeeAdd").modal("toggle");
        },
       
    }
}
</script>
